var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('van-list',_vm._l((_vm.list),function(item){return _c('van-cell',{key:item,staticClass:"menu-item",class:{ selectLianjiuMenuItem: _vm.activeNames === item.id },attrs:{"title":item.name},nativeOn:{"click":function($event){return _vm.handleFirst(item)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }